// extracted by mini-css-extract-plugin
export default {"container":"empty-state-banner_container__0gU4k","icon":"empty-state-banner_icon__rsoii","text":"empty-state-banner_text__vYu2H","link":"empty-state-banner_link__JY8td"};